import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Store } from '@ngxs/store';
import { GenericLookupDto } from 'src/core/models/generic-lookup/generic-lookup.dto';
import { GenericLookupTypeState } from 'src/core/states/generic-lookup-type/generic-lookup-type.state';

@Component({
  selector: 'ca-generic-lookup-radio-selector',
  templateUrl: './generic-lookup-radio-selector.component.html',
  styleUrls: ['./generic-lookup-radio-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => GenericLookupRadioSelectorComponent),
    },
  ],
  standalone: false,
})
export class GenericLookupRadioSelectorComponent implements ControlValueAccessor {
  @Input()
  idPrefix: string;

  @Input()
  set genericLookupType(value: any) {
    this._genericLookupType = value;

    this.setItems();
  }

  get genericLookupType(): any {
    return this._genericLookupType;
  }

  value: number | null = null;
  isDisabled: boolean = false;
  items: GenericLookupDto[];
  trackByLookupId = (_index: number, item: GenericLookupDto): number => item.id;

  private _genericLookupType: any;

  constructor(private store: Store) {}

  onChange(value: number | null) {}

  onTouched() {}

  onRadioChange(id: number): void {
    this.value = id;
    this.onChange(id);
    this.onTouched();
  }

  writeValue(value: number | null): void {
    this.value = value;
  }

  registerOnChange(fn: (value: number | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  private setItems(): void {
    const stateItemsFn = this.store.selectSnapshot(GenericLookupTypeState.getGenericLookups);

    this.items = stateItemsFn(this.genericLookupType);
  }
}
